import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SaveReservationUseCase } from '@/core/domain/reservation/usecases/saveReservation.usecase';
import { ReservationRepository } from '@/core/domain/reservation/repositories/reservation.respository';
import { ReservationImplRepository } from './reservation-imp.respository';
import { ClearReservationUseCase } from '@/core/domain/reservation/usecases/clearReservation.usecase';
import { RestoreReservationUseCase } from '@/core/domain/reservation/usecases/restoreReservation.usecase';
import { UpdateReservationUseCase } from '@/core/domain/reservation/usecases/updateReservation.usecase';
import { InsuranceRepository } from '@/core/domain/reservation/repositories/insurance.repository';
import { ToggleInsuranceUseCase } from '@/core/domain/reservation/usecases/insurance.usecase';
import { InsuranceImplRepository } from './insurance-impl.repository';
import { DetailsRepository } from '@/core/domain/reservation/repositories/details.repository';
import { ToggleDetailsUseCase } from '@/core/domain/reservation/usecases/details.usecase';
import { DetailsImplRepository } from './details-impl.repository';
import { DoReservationUseCase } from '@/core/domain/reservation/usecases/doReservation.usecase';
import { GetReservationUseCase } from '@/core/domain/reservation/usecases/getReservation.usecase';

const saveReservationUseCaseFactory = (
    reservationRepository: ReservationRepository,
) => new SaveReservationUseCase(reservationRepository);

const getReservationUseCaseFactory = (
    reservationRepository: ReservationRepository,
) => new GetReservationUseCase(reservationRepository);

const doReservationUseCaseFactory = (
    reservationRepository: ReservationRepository,
) => new DoReservationUseCase(reservationRepository);

const clearReservationUseCaseFactory = (
    reservationRepository: ReservationRepository,
) => new ClearReservationUseCase(reservationRepository);

const restoreReservationUseCaseFactory = (
    reservationRepository: ReservationRepository,
) => new RestoreReservationUseCase(reservationRepository);

const updateReservationUseCaseFactory = (
    reservationRepository: ReservationRepository,
) => new UpdateReservationUseCase(reservationRepository);

const toggleInsuranceUseCaseFactory = (
    insuranceRepository: InsuranceRepository,
) => new ToggleInsuranceUseCase(insuranceRepository);
const toggleDetailsUseCaseFactory = (detailsRepository: DetailsRepository) =>
    new ToggleDetailsUseCase(detailsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: SaveReservationUseCase,
            useFactory: saveReservationUseCaseFactory,
            deps: [ReservationImplRepository],
        },
        {
            provide: ReservationRepository,
            useClass: ReservationImplRepository,
        },
        {
            provide: ClearReservationUseCase,
            useFactory: clearReservationUseCaseFactory,
            deps: [ReservationImplRepository],
        },
        {
            provide: RestoreReservationUseCase,
            useFactory: restoreReservationUseCaseFactory,
            deps: [ReservationImplRepository],
        },
        {
            provide: UpdateReservationUseCase,
            useFactory: updateReservationUseCaseFactory,
            deps: [ReservationImplRepository],
        },
        {
            provide: ToggleInsuranceUseCase,
            useFactory: toggleInsuranceUseCaseFactory,
            deps: [InsuranceImplRepository],
        },
        {
            provide: DoReservationUseCase,
            useFactory: doReservationUseCaseFactory,
            deps: [ReservationImplRepository],
        },
        {
            provide: InsuranceRepository,
            useClass: InsuranceImplRepository,
        },
        {
            provide: ToggleDetailsUseCase,
            useFactory: toggleDetailsUseCaseFactory,
            deps: [DetailsImplRepository],
        },
        {
            provide: DetailsRepository,
            useClass: DetailsImplRepository,
        },
        {
            provide: GetReservationUseCase,
            useFactory: getReservationUseCaseFactory,
            deps: [ReservationImplRepository],
        },
    ],
})
export class ReservationModule {}
